export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/livings/index/resources/computed.js